import { CreateExchangeRateReferenceConfigProps } from './createExchangeRateReferenceConfigProps';
import { smallCurrencyFormat } from '../../../../../../common/formats/formats';
import {
  ConfigurationSpreadsheets,
  ParserParams,
  RowConfigProps,
} from '../../../../../../common/types/scalarSpreadsheet';
import { ValuationsApproach } from '../../../../../../common/types/valuation';
import { SpreadsheetConfig } from '../../../../../../components/ScalarSpreadsheet/utilities/SpreadsheetConfig';
import { getApproachTableName } from '../../../../../ValuationsAllocation/util';

const createExchangeRateReferenceConfig = ({
  approach,
  exchangeRateRowInput,
}: CreateExchangeRateReferenceConfigProps) => {
  const name = getApproachTableName({
    approach: approach as ValuationsApproach,
    tableSuffix: 'exchangeRates',
  });

  const parser = ({ rowConfig }: ParserParams<RowConfigProps>) =>
    rowConfig.reduce((acc, row, index) => {
      const cell = {
        ...row,
        key: `A${index + 1}`,
        colLegend: 'A',
        value: index === 0 ? 'Exchange Rate to Selected Currency' : 1,
      };
      return {
        ...acc,
        [cell.key]: cell,
      };
    }, {});

  return new SpreadsheetConfig({
    currencyFormatter: false,
    format: undefined,
    totalParser: undefined,
    unitsFormatter: false,
    name,
    columns: [{}],
    rowConfig: [
      {
        alias: 'title',
        value: 'Currency',
        className: 'formatter-cell division-bottom-only',
      },
      ...exchangeRateRowInput.map(input => ({
        ...input,
        format: smallCurrencyFormat,
      })),
    ],
    parser,
    tableData: {},
  }) as unknown as ConfigurationSpreadsheets;
};

export default createExchangeRateReferenceConfig;
